import { render, staticRenderFns } from "./PlanningOrdersTable.vue?vue&type=template&id=72216394&"
import script from "./PlanningOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PlanningOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports